import { combineReducers } from 'redux'
import reminders from './reminders'
import general from './general'

export default combineReducers({
  reminders,
  general
})
